export const capitaliseFirst = (str: string): string => {
  return (str.charAt(0).toUpperCase() + str.slice(1))
    ?.replaceAll('gp', 'GP')
    ?.replaceAll('Gp', 'GP')
    ?.replaceAll('eppoc', 'ePPOC')
    ?.replaceAll('Eppoc', 'ePPOC')
    ?.replaceAll('egfr', 'eGFR')
    ?.replaceAll('Egfr', 'eGFR');
};
